"use client"

import { Menu } from "lucide-react"

import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet"

type SiteHeaderMobileNavProps = {
  items: Array<{
    title: string
    href: string
  }>
}

export function SiteHeaderMobileNav({ items }: SiteHeaderMobileNavProps) {
  return (
    <div className="ml-auto xl:hidden">
      <Sheet>
        <SheetTrigger asChild>
          <button
            type="button"
            aria-label="打开导航菜单"
            className="inline-flex size-10 items-center justify-center rounded-full border border-border bg-background transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 md:size-8"
          >
            <Menu className="size-5 md:size-4" aria-hidden="true" />
          </button>
        </SheetTrigger>
        <SheetContent side="right" className="w-[min(22rem,85vw)] p-0">
          <SheetTitle className="border-b px-6 py-5 text-left text-base">
            导航菜单
          </SheetTitle>
          <nav aria-label="主导航" className="flex flex-col p-3">
            {items.map(({ title, href }) => (
              <SheetClose asChild key={`${title}-${href}`}>
                <a
                  href={href}
                  className="rounded-lg px-3 py-3 text-base transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                >
                  {title}
                </a>
              </SheetClose>
            ))}
          </nav>
        </SheetContent>
      </Sheet>
    </div>
  )
}
